import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Media = ({ mediaConfig }) => {
    const isVideo = !!(mediaConfig.video_url);
    
    return (
        <div className={styles.media}>
            {isVideo ? 
                mediaConfig.video_url && 
                <video
                    className={styles.mediaVideo}x
                    controls={true}
                    src={mediaConfig.video_url}
                    poster={mediaConfig.img_url ? mediaConfig.img_url : ''}
                    webkit-playsinline="true"
                    playsInline={true}
                    autoPlay="autoplay"
                    x5-video-player-fullscreen="false"
                    x5-video-player-type="h5"
                    x5-playsinline="true"
                    controlslist="nodownload"
                    οncοntextmenu="return false"
                /> 
                : mediaConfig.img_url &&
                <img className={styles.mediaPic} src={mediaConfig.img_url} />
            }
        </div>
    );
};

Media.propTypes = {
    mediaConfig: PropTypes.object
};

export default errorBoundary(Media);
